module.exports = __webpack_public_path__ + "img/a3.47e5630e.png";